import swal from 'sweetalert'

export const showAlert = (string) => swal(string, {buttons: { cancel: 'OK'}})
export const showAlertWithCallback = (string, callback) => swal(string, {buttons: { cancel: 'OK'}}).then(() => {
  callback()
})

